import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';
import { LineStatus } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}interventionreportlines/status`;

interface SetInterventionReportLineStatusCommandPayload {
  interventionReportLineIds: string[];
  status: LineStatus;
}

const setInterventionReportLineStatusCommand = async (
  payload: SetInterventionReportLineStatusCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.PUT,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default setInterventionReportLineStatusCommand;
